import { defineExample } from './util'

export const invCircle2Ex1 = defineExample({
  metadata: { author: 'unknown' },
  renderSettings: {
    exposure: 1.525,
    skipIters: 20,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    camera: {
      zoom: 0.21533175184661388,
      position: [1.0133492946624756, -0.4138084650039673],
    },
  },
  transforms: {
    d2523f69_dd2d_49cb_b14f_d9448e0bfb31: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: 0.31643110513687134, y: -0.005779106169939041 },
      variations: {
        bc571c35_0b03_4865_a765_d00cd71031a6: {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 1, a: 0, b: 0, cx: 0, cy: 0, restricted: 1 },
        },
      },
    },
    '65355ec1_be15_4802_a57e_bf8127dcc79b': {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.22692228853702545, y: 0.23797284066677094 },
      variations: {
        d206ee66_3217_4da9_8c3a_c6953a96f67a: {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 1, a: -2, b: 0, cx: -2, cy: 0, restricted: 1 },
        },
      },
    },
    '1f4a3cbd_644a_423a_a8b6_8078b743c758': {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.2525634765625, y: -0.004009046591818333 },
      variations: {
        ad3a5e09_a04f_41d1_a82f_df6b1bc30bf1: {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 1, a: 2, b: 0, cx: 2, cy: 0, restricted: 1 },
        },
      },
    },
    fc1d7c4e_13e0_430c_b0e1_eb065269b5d1: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.09233655035495758, y: -0.24072265625 },
      variations: {
        faf02b1e_5b58_43b1_8b57_41b1aab6275d: {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 1, a: 0, b: 2, cx: 0, cy: 2, restricted: 1 },
        },
      },
    },
    bd4eaa35_bc6c_432b_a3e7_591c44606fb3: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: 0.21764494478702545, y: 0.23115620017051697 },
      variations: {
        '40d782b6_3e17_4267_896f_4824267d7058': {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 1, a: 0, b: -2, cx: 0, cy: -2, restricted: 1 },
        },
      },
    },
    '1557740e_9162_4d63_8789_54e9a0a98462': {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: 0.2560778260231018, y: -0.1693822145462036 },
      variations: {
        b631c3e8_7aeb_49e1_ab9a_f957e3f97568: {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 2, a: -2, b: 2, cx: -3, cy: 3, restricted: 1 },
        },
      },
    },
    '1281266a_a73d_4113_b309_883677eea00d': {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.006668880581855774, y: -0.0064568668603897095 },
      variations: {
        '9ca161e3_52d3_4278_8df9_970aa70c6a52': {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 2, a: 2, b: 2, cx: 3, cy: 3, restricted: 1 },
        },
      },
    },
    cd40df02_fd5b_4892_8c25_1268f417b507: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.2659398317337036, y: 0.1798224151134491 },
      variations: {
        a00439e8_af92_4341_b4de_ca166c0b1bb4: {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 2, a: -2, b: -2, cx: -3, cy: -3, restricted: 1 },
        },
      },
    },
    d6abfc2f_bf89_4085_ab06_fa68c627b60e: {
      probability: 1,
      preAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      postAffine: { a: 1, b: 0, c: 0, d: 0, e: 1, f: 0 },
      color: { x: -0.1650775969028473, y: 0.26824629306793213 },
      variations: {
        '05ecbcad_19ff_45e9_9920_843333f2e3bf': {
          type: 'invCircle2Var',
          weight: 1,
          params: { radius: 2, a: 2, b: -2, cx: 3, cy: -3, restricted: 1 },
        },
      },
    },
  },
})
